var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    [
      _c(
        "h1",
        [
          _vm._v(
            " " +
              _vm._s(_vm.$t("booking.booking")) +
              " " +
              _vm._s(_vm.booking.reservation_number) +
              " "
          ),
          _c("v-chip", [_vm._v(_vm._s(_vm.booking.name))])
        ],
        1
      ),
      _c("h2", { staticClass: "mt-3" }, [
        _vm._v(_vm._s(_vm.$t("booking.passengers")))
      ]),
      _vm._l(_vm.booking.passengers, function(passenger) {
        return _c("div", [
          _c(
            "fieldset",
            { staticClass: "pd-1 custom-fieldset" },
            [
              _c(
                "v-row",
                [
                  _c(
                    "v-col",
                    {
                      staticClass:
                        "text-center align-content-center fill-height align-content-center",
                      attrs: { md: "1", cols: "1" }
                    },
                    [
                      _c(
                        "v-icon",
                        {
                          staticStyle: {
                            "font-size": "46px",
                            color: "rgba(0, 0, 0, 0.32)"
                          }
                        },
                        [_vm._v("fa-user-circle")]
                      )
                    ],
                    1
                  ),
                  _c(
                    "v-col",
                    { attrs: { cols: "5" } },
                    [
                      _c("v-text-field", {
                        staticClass: "no-line-after-input",
                        attrs: {
                          label: _vm.$t("booking.passenger"),
                          value: passenger,
                          disabled: ""
                        }
                      })
                    ],
                    1
                  )
                ],
                1
              )
            ],
            1
          )
        ])
      }),
      _vm.$store.getters.hasPermission("viewInvoices")
        ? [
            _c("h2", [_vm._v(_vm._s(_vm.$t("global.invoice")))]),
            _vm.booking.invoices.length === 0
              ? _c("span", [
                  _vm._v(" " + _vm._s(_vm.$t("booking.invoiceNotSet")) + " ")
                ])
              : _vm._l(_vm.booking.invoices, function(invoice) {
                  return _c(
                    "span",
                    { key: invoice.id },
                    [
                      _c(
                        "v-row",
                        [
                          _c(
                            "v-col",
                            {
                              staticClass:
                                "text-center align-content-center fill-height align-content-center",
                              attrs: { md: "1", cols: "1" }
                            },
                            [
                              _c(
                                "v-icon",
                                {
                                  staticStyle: {
                                    "font-size": "46px",
                                    color: "rgba(0, 0, 0, 0.32)"
                                  }
                                },
                                [_vm._v("mdi-file-document")]
                              )
                            ],
                            1
                          ),
                          _c(
                            "v-col",
                            { attrs: { md: "3", cols: "5" } },
                            [
                              _c("v-text-field", {
                                staticClass: "no-line-after-input",
                                attrs: {
                                  label: _vm.$t(
                                    "invoice.details.invoiceNumber"
                                  ),
                                  value: invoice.number,
                                  disabled: ""
                                }
                              })
                            ],
                            1
                          ),
                          _c(
                            "v-col",
                            { attrs: { md: "7", cols: "12" } },
                            _vm._l(invoice.items, function(invoiceItem) {
                              return _c(
                                "v-row",
                                { key: invoiceItem.id },
                                [
                                  _c("v-text-field", {
                                    staticClass: "no-line-after-input",
                                    attrs: {
                                      label: _vm.$t(
                                        "booking.other.serviceName"
                                      ),
                                      disabled: "",
                                      value:
                                        invoiceItem.name +
                                        " " +
                                        invoiceItem.gross_in_currency +
                                        " " +
                                        invoiceItem.currency
                                    }
                                  })
                                ],
                                1
                              )
                            }),
                            1
                          ),
                          _c("v-spacer"),
                          _c(
                            "v-col",
                            { staticClass: "text-right", attrs: { cols: "1" } },
                            [
                              _c(
                                "v-btn",
                                {
                                  attrs: {
                                    to: "/invoices/details/" + invoice.id,
                                    icon: ""
                                  }
                                },
                                [_c("v-icon", [_vm._v("remove_red_eye")])],
                                1
                              )
                            ],
                            1
                          )
                        ],
                        1
                      )
                    ],
                    1
                  )
                })
          ]
        : _vm._e()
    ],
    2
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }